import { postJson } from '../../../common/data/common-data-service';
import { IHabitTrackerChartResponse } from '../habit-tracker-interfaces';

export const getHabitTrackerChartData = async (todo_id: number, startDate: number, endDate: number) : Promise<IHabitTrackerChartResponse> => {
    return await postJson(`/api/habit-tracker/calendar-data`, {
        todo_id,
        startDate,
        endDate,
    });
};